module.exports = __webpack_public_path__ + "static/img/more.37d39187.png";